import { useAtom } from 'jotai';

import {
  tshirtAndShieldAtom,
  TshitAndShieldTypes,
} from '@/store/tshirtAndShield';

const useTshirtAndShield = () => {
  const [data, setData] = useAtom(tshirtAndShieldAtom);

  const updateTshirtAndShield = (updates: Partial<TshitAndShieldTypes>) => {
    setData((prev) => {
      if (!prev) return updates as TshitAndShieldTypes;
      return {
        ...prev,
        ...updates,
      };
    });
  };

  const setTshirtAndShield = (data: TshitAndShieldTypes) => {
    setData(data);
  };

  return {
    data,
    updateTshirtAndShield,
    setTshirtAndShield,
  };
};

export default useTshirtAndShield;
